import { ReactElement } from 'react';

import { Box, CircularProgress } from '@mui/material';

export const LoadingPanel = (): ReactElement => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: 'calc(100vh - 222.99px)',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
};
